import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { VesselImage } from 'anchor-shared/lib/model/entity/vesselImage';
import { DialogsService } from '../../../../core/services/dialog.service';
import { Subscription } from 'rxjs';
import { unsubscribeFromAll } from '../../../../core/pure-functions/rx-helper';
import { ContainsSubscriptions } from '../../../../core/services/interfaces/contains-subscriptions';
import { EnvironmentalMediaService } from '../../../../core/services/environmental-media.service';

@Component({
  selector: 'app-vessel-photo-gallery',
  templateUrl: './vessel-photo-gallery.component.html',
  styleUrls: ['./vessel-photo-gallery.component.scss'],
})
export class VesselPhotoGalleryComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  subs: Subscription[] = [];

  @Input() vesselImages: VesselImage[] = [];
  @Input() mobile: boolean;
  @Input() vesselVideo: string = null;

  photoToDisplay: VesselImage[] = [];
  numberOfPhotos: number = 0;

  constructor(
    private dialogService: DialogsService,
    public environmentalMediaService: EnvironmentalMediaService,
  ) {}

  open() {
    const galleryDialogSub = this.dialogService
      .PhotoGalleryDialog(this.vesselImages, this.vesselVideo)
      .subscribe(() => {});
    this.subs.push(galleryDialogSub);
  }

  ngOnInit(): void {
    this.numberOfPhotos = this.vesselImages.length;
    if (this.mobile) {
      this.photoToDisplay = this.vesselImages.slice(0, 1);
    } else {
      this.photoToDisplay = this.vesselImages.slice(0, 5);
    }
  }

  ngOnDestroy(): void {
    unsubscribeFromAll(this.subs);
  }
}
